import { render, staticRenderFns } from "./RewardPeriodDetailInformation.vue?vue&type=template&id=04c7161c"
import script from "./reward-period-detail-information.ts?vue&type=script&lang=ts&external"
export * from "./reward-period-detail-information.ts?vue&type=script&lang=ts&external"
import style0 from "./reward-period-detail-information.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports